import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useAppDispatch, useAppSelector } from './ReduxToolkit/hook';
import { fetchPanelConfig } from './ReduxToolkit/Reducers/PanelConfigReducer';
import Routers from './Routes';

function App() {
  const dispatch = useAppDispatch();
  const panelConfig = useAppSelector(state => state.panelConfig.data);
  const panelLoading = useAppSelector(state => state.panelConfig.loading);

  useEffect(() => {
    dispatch(fetchPanelConfig());
  }, [dispatch]);


  useEffect(() => {
    if (!panelConfig) return;

    const root = document.documentElement;

    // colori tema
    root.style.setProperty('--theme-default', panelConfig.theme.primary);
    root.style.setProperty('--theme-secondary', panelConfig.theme.secondary);

    // TITLE della pagina
    if (panelConfig.title) {
      document.title = panelConfig.title;
    }

    // FAVICON
    if (panelConfig.images?.favicon) {
      let link =
        document.querySelector<HTMLLinkElement>("link[rel='icon']") ||
        document.querySelector<HTMLLinkElement>("link[rel='shortcut icon']");

      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }

      link.type = 'image/x-icon';
      link.href = panelConfig.images.favicon; 
    }
  }, [panelConfig]);

  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
